import React, { useState } from 'react';
import './TemperatureDisplayDialog.scss';
import { Modal } from 'react-bootstrap';
import { useAppSelector } from '../../redux/hooks';
import { selectConfigData } from '../../redux/config/configSlice';

interface TemperatureDisplayDialogProps {
    sensorId: string;
    isOpen: boolean;
    handleClose: () => void;
}

const TemperatureDisplayDialog: React.FC<TemperatureDisplayDialogProps> = ({ sensorId, handleClose, isOpen }) => {
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const configData = useAppSelector(selectConfigData);

    return (
        <Modal show={!!sensorId && isOpen} centered dialogClassName="temperature-display-modal" onExited={() => setIframeLoaded(false)}>
            {iframeLoaded && (
                <button className='dialog-close-btn' onClick={handleClose}>&#10005;</button>
            )}
            <iframe
                src={`${configData?.temperatureDisplayBaseUrl}/?sensorId=${sensorId}`}
                className='temp-display-iframe'
                title="Temperature Display"
                height={632}
                width={400}
                onLoad={() => setIframeLoaded(true)}
            />
        </Modal>
    )
}

export default TemperatureDisplayDialog;
